export class TransfersOtherBanksEventType {
	
	static INIT = 'INIT_TRANSFER_OTHER_BANKS';

	static STEPS = {
		TRANSFER_TYPE: 'TRANSFER_TYPE',
		FAVORED_DATA: 'FAVORED_DATA',
		TRANSFER_DATA: 'TRANSFER_DATA',
		SECURITY_CHECK:  'SECURITY_CHECK',
		TRANSFER_CONFIRMATION:  'TRANSFER_CONFIRMATION',
		TRANSFER_RESULT:  'TRANSFER_RESULT'
	};

	static SCHEDULE = {
		SCHEDULE: 'SCHEDULE'
	};

	static TRANSFER = {
		SEND: 'SEND',
		CONFIRM: 'CONFIRM'
	};

	static MODAL = {
		TRUE_MODAL: 'TRUE_MODAL'
	};

	static ACTIONS = {
		BUTTONS: 'TRANSFER_BUTTONS'
	};

	static ERROR = 'TRANSFER_ERROR';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfers-other-banks.event.type.ts